import * as React from 'react';

import {
  GenerateQuestionStep,
  useScopedStepAtom,
} from '~teacher/components/QuizEditor/GenerateQuestionDialog/atom';

import { assertUnreachable } from '../../../../util/assertUnreachable';
import { GenerateQuestionStep1 } from './GenerateQuestionStep1';
import { GenerateQuestionStep2 } from './GenerateQuestionStep2';

interface Props {
  onClose: () => void;

  refreshQuestions: () => Promise<void>;
}
export function GenerateQuestion({ onClose, refreshQuestions }: Props) {
  const [currentStep] = useScopedStepAtom();
  switch (currentStep) {
    case GenerateQuestionStep.Settings:
      return <GenerateQuestionStep1 />;
    case GenerateQuestionStep.Questions:
      return (
        <GenerateQuestionStep2
          onClose={onClose}
          refreshQuestions={refreshQuestions}
        />
      );
    default:
      assertUnreachable(currentStep);
  }
}
